module.exports = __webpack_public_path__ + "img/energy4.e9964865.jpg";